import styled from 'styled-components'

const Container = styled.div`
  margin-bottom: 50px;

  &:empty {
    display: none;
  }
`

const SmallPrint = styled.h3`
  margin-bottom: 10px;
`

export { Container, SmallPrint }
